import { TOAST_DISPATCHERS } from '@/shared/constants/store-constants/toast'
import massPaymentsService from '@/shared/services/mass-payments.service'
import { DETAIL_MASS_PAYMENT_DISPATCHERS } from '@/shared/constants/store-constants/detailMassPayment'
import { getQuery, setQuery } from '@/shared/lib/utils/queryParams'
import { downloadFile } from '@/shared/lib/utils/downloadFile'
import i18n from '@/app/i18n'

export default {
  resetStore({ commit }) {
    commit('RESET_STORE')
  },

  setSuccessFileLoaded({ commit }, payload) {
    commit('SET_SUCCESS_FILE_LOADED', payload)
  },

  onClearSearchAndFilters({ commit, state, dispatch }) {
    commit('CLEAR_ITEMS')

    commit('SET_SEARCH', null)

    commit('SET_FILTER', { key: 'contractor_statuses', payload: [] })
    commit('SET_FILTER', { key: 'payment_statuses', payload: [] })

    dispatch(DETAIL_MASS_PAYMENT_DISPATCHERS.goToLoadDetail, state.id, {
      root: true,
    })
  },

  onSelectSort({ commit, state, dispatch }, payload) {
    commit('CLEAR_ITEMS')
    commit('SET_SORT', payload)
    dispatch(DETAIL_MASS_PAYMENT_DISPATCHERS.goToLoadDetail, state.id, {
      root: true,
    })
  },

  async goToAddUser({ commit, dispatch, state }, payload) {
    commit('SET_ACTION_LOADING', true)
    commit('RESET_PAGE')

    try {
      await massPaymentsService.addUserMassPayment(state.id, {
        items: [{ ...payload, coin: 'usdt', name: '' }],
      })

      await dispatch(DETAIL_MASS_PAYMENT_DISPATCHERS.goToLoadDetail, state.id, {
        root: true,
      })

      dispatch(
        TOAST_DISPATCHERS.setSuccessMessage,
        {
          title: i18n.global.t(
            'DetailMassPayments | modal | toast | invite_sent | title'
          ),
          message: '',
        },
        { root: true }
      )
    } catch (e) {
      if (!e.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },

  async goToCopy({ commit, dispatch, state }) {
    commit('SET_ACTION_LOADING', true)

    try {
      const payload = await massPaymentsService.copyMassPayment(state.id)

      return { success: true, payload }
    } catch (e) {
      if (!e.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },

  async goToDeleteUsers({ commit, dispatch, state }, payload) {
    commit('SET_ACTION_LOADING', true)

    try {
      await massPaymentsService.deleteUserMassPayment(state.id, {
        item_ids: payload,
      })

      await dispatch(DETAIL_MASS_PAYMENT_DISPATCHERS.goToLoadDetail, state.id, {
        root: true,
      })

      dispatch(TOAST_DISPATCHERS.setSuccessMessage, {}, { root: true })

      return { success: true }
    } catch (e) {
      if (!e.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },

  onSearch({ commit, getters, state, dispatch }, payload) {
    commit('CLEAR_ITEMS')

    commit('SET_SEARCH', payload)

    setQuery(getters.paramsQueryFilters)

    dispatch(DETAIL_MASS_PAYMENT_DISPATCHERS.goToLoadDetail, state.id, {
      root: true,
    })
  },

  getQueryParams({ commit, dispatch }, payload) {
    const { search, ...filters } = getQuery([
      'contractor_statuses',
      'payment_statuses',
    ])

    Object.keys(filters).forEach((key) => {
      commit('SET_FILTER', { key, payload: filters[key] })
    })

    commit('SET_SEARCH', search)

    dispatch(DETAIL_MASS_PAYMENT_DISPATCHERS.goToLoadDetail, payload, {
      root: true,
    })
  },

  onSelectFilter({ commit, state, dispatch, getters }, payload) {
    commit('CLEAR_ITEMS')

    commit('SET_FILTER', payload)

    setQuery(getters.paramsQueryFilters)

    dispatch(DETAIL_MASS_PAYMENT_DISPATCHERS.goToLoadDetail, state.id, {
      root: true,
    })
  },
  setId({ commit, state }, payload) {
    commit('SET_ID', payload)
  },

  onSelected({ commit }, payload) {
    commit('SET_SELECTED', payload)
  },
  parsePayload({ commit }, payload) {
    commit('SET_ITEMS', {
      items: payload.items,
      total: payload.total,
      total_all: payload.total_all,
    })
    commit('SET_FORM_DATA', payload.mass_payment_info)
  },
  async goToLoadDetail({ dispatch, commit, state }, payload) {
    commit('SET_LOADING', true)

    try {
      const params = {
        search: state.search,
        ...state.filters,
        ...state.sorting,
        page: 1,
        limit: 9999,
      }
      const { data } = await massPaymentsService.getDetailMassPayment(
        payload,
        params
      )

      dispatch(DETAIL_MASS_PAYMENT_DISPATCHERS.parsePayload, data, {
        root: true,
      })
    } catch (e) {
      if (!e.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async updateMassPayment({ commit, dispatch, state }, data) {
    try {
      commit('SET_ACTION_LOADING', true)
      await massPaymentsService.updateMassPayment(state.id, data)
      dispatch(TOAST_DISPATCHERS.setSuccessMessage, {}, { root: true })
      await dispatch('goToLoadDetail', state.id)
      return { success: true }
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
      return { success: false }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },

  async getPaymentInfo({ dispatch, commit, state }) {
    try {
      const response = await massPaymentsService.getPaymentInfo(state.id, {
        item_ids: state.selected.map((item) => item.id),
      })

      commit('SET_FORM_DATA_PAYMENT_INFO', response.required_balances[0])
    } catch (e) {
      if (!e.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
      return { success: false }
    }
  },

  async goToUploadInviteFile({ commit, state, dispatch }, payload) {
    commit('SET_ACTION_LOADING', true)

    try {
      const response = await massPaymentsService.uploadMassPaymentFile(
        state.id,
        payload
      )
      await dispatch(DETAIL_MASS_PAYMENT_DISPATCHERS.goToLoadDetail, state.id, {
        root: true,
      })

      commit('SET_SUCCESS_FILE_LOADED', true)

      return { payload: response.data }
    } catch (e) {
      if (!e.isHandled) {
        const errorCode = e.response?.data?.code
        dispatch(
          TOAST_DISPATCHERS.setErrorMessage,
          {
            title: i18n.global.t('ToastError | title'),
            message: i18n.global.t(
              errorCode === 'payroll-002'
                ? 'ToastError | message | payroll | invalidFile'
                : 'ToastError | message'
            ),
          },
          { root: true }
        )
      }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },

  async goToDownloadCSVExample({ commit, dispatch }) {
    commit('SET_EXAMPLE_LOADING', true)

    try {
      const response = await massPaymentsService.downloadExample({
        format: 'csv',
      })

      downloadFile(response, 'example.csv')

      return { success: true }
    } catch (e) {
      if (!e.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_EXAMPLE_LOADING', false)
    }
  },

  async goToDownloadTableRow({ commit, state, dispatch }) {
    commit('SET_EXAMPLE_LOADING', true)

    try {
      const response = await massPaymentsService.downloadTableRow(state.id, {
        format: 'csv',
      })

      downloadFile(response, `${state.formData.name}.csv`)
    } catch (e) {
      if (!e.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_EXAMPLE_LOADING', false)
    }
  },

  async goToPayItems({ state, dispatch, commit }) {
    commit('SET_ACTION_LOADING', true)

    try {
      await massPaymentsService.payItems(state.id, {
        item_ids: state.selected.map((item) => item.id),
      })
      commit('CLEAR_ITEMS')

      setTimeout(async () => {
        await dispatch(
          DETAIL_MASS_PAYMENT_DISPATCHERS.goToLoadDetail,
          state.id,
          {
            root: true,
          }
        )
      }, 500)

      dispatch(TOAST_DISPATCHERS.setSuccessMessage, {}, { root: true })

      return { success: true }
    } catch (e) {
      if (!e.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
      return { success: false }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },

  async reInviteUser({ commit, dispatch }, payload) {
    commit('SET_RE_INVITE_LOADING', true)

    try {
      await massPaymentsService.reInviteUser(payload)
      commit('UPDATE_AFTER_RE_INVITE', payload)
      dispatch(TOAST_DISPATCHERS.setSuccessMessage, {}, { root: true })
    } catch (e) {
      if (!e.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_RE_INVITE_LOADING', false)
    }
  },

  async updateUser({ commit, state, dispatch }, { itemId, payload }) {
    commit('SET_ACTION_LOADING', true)

    try {
      await massPaymentsService.updateUser(state.id, itemId, payload)
      await dispatch(DETAIL_MASS_PAYMENT_DISPATCHERS.goToLoadDetail, state.id, {
        root: true,
      })
      dispatch(TOAST_DISPATCHERS.setSuccessMessage, {}, { root: true })

      return { success: true }
    } catch (e) {
      if (!e.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },
}
